import { render } from "./TemplateE.vue?vue&type=template&id=499a0a42"
import script from "./TemplateE.vue?vue&type=script&lang=js"
export * from "./TemplateE.vue?vue&type=script&lang=js"
script.render = render

export default script